import React from "react";
import { motion, AnimateSharedLayout } from "framer-motion";
import "./styles.css";

const tabs = [
  { name: "Red", color: "#f00" },
  { name: "Purple", color: "#b1f" },
  { name: "Pink", color: "#f08" },
  { name: "Blue", color: "#05f" }
];

export default function App() {
  const [selected, setSelected] = React.useState(0);

  return (
    <div name="Container" className="container">
      <AnimateSharedLayout>
        {tabs.map(({ name, color }, i) => (
          <motion.div
            name="Tab"
            className="tab"
            key={i}
            animate={{ color: i === selected ? "#fff" : "#222" }}
            onTap={() => setSelected(i)}
          >
            {name}
            {i === selected && (
              <motion.div
                name="Background"
                className="selection"
                layoutId="selected"
                style={{ borderRadius: 30 }}
                animate={{ backgroundColor: color }}
                // transition={{ duration: 2 }}
              />
            )}
          </motion.div>
        ))}
      </AnimateSharedLayout>
    </div>
  );
}
